// extracted by mini-css-extract-plugin
export var form = "_ej-0";